import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function AccessDenied() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        px: 2,
      }}
    >
      <Typography
        variant="h3"
        sx={{ color: "#d32f2f", fontWeight: 700, mb: 2 }}
      >
        Access Denied
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: "#64748b", mb: 4, fontSize: "16px" }}
      >
        You are not authorized to view this page.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/product-catalogue")}
        sx={{ textTransform: "none" }}
      >
        Go Back to product catalogue
      </Button>
    </Box>
  );
}
